import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MoveDownRight: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M19 13V19H13' }],
    ['path', { d: 'M5 5L19 19' }],
  ],
];

export default MoveDownRight;
